import { render, staticRenderFns } from "./imby-pane-navigation.vue?vue&type=template&id=99bc92be&"
import script from "./imby-pane-navigation.vue?vue&type=script&lang=js&"
export * from "./imby-pane-navigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports